import { FC } from "react";
import { Heading } from "@/components/Html/Heading";
import { Section } from "@/components/Html/Section";

interface Props {
  title: string;
  description: string;
}

export const Item: FC<Props> = ({ title, description }) => {
  return (
    <Section className="min-h-[226px] w-full rounded-ee-[24px] border-b border-r border-solid border-primary py-[24px] pr-[24px] md:w-[calc((100%-32px)/2)]">
      <Heading className="mb-[12px] text-[22px]">{title}</Heading>
      <p>{description}</p>
    </Section>
  );
};
